@use "variables" as *;

.icon,
.passengerCount {
  color: $content-secondary-color;
}
